import React, { useState } from 'react';
import { Col, Container, Row, Button } from 'reactstrap';
import grabbitSnack from "../../../../../assets/images/OUR SERVICES/grabbitsnack.jpg";
import wevendSnack from "../../../../../assets/images/OUR SERVICES/wevendSnack.jpeg";
import vendoSnack from "../../../../../assets/images/OUR SERVICES/vendosnack.png";
import grabbit from "../../../../../assets/images/OUR SERVICES/grabbit.png";
import wevend from "../../../../../assets/images/OUR SERVICES/3.We-Vend.png";
import vendo from "../../../../../assets/images/OUR SERVICES/vendo.png";
import bigBasket from "../../../../../assets/images/OUR SERVICES/bigbasket.png";
import bigBasket2 from "../../../../../assets/images/OUR SERVICES/bigbasketmachine.png";
import EnquiryModal from '../../../../../common/pages/enquiryModal';
const SnacksMachine = () => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);
    return (
        <React.Fragment>

            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Snacks Vending Machines</h2>

                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">
                                <Col lg={6} md={12} className="text-center">
                                    <img src={bigBasket2} alt="BigBasket Snack Vending Machine" className="img-fluid rounded" style={{ width: "100%", height: "auto",  objectFit: "container"}} />
                                </Col>
                                <Col lg={6} md={12}>
                                    <div className='text-center'>
                                        <img src={bigBasket} alt="bigBasket Logo" className="mb-3" style={{ width: "100px" }} />
                                    </div>
                                    <h3 className="fw-bold" style={{ color: "rgb(52, 81, 159)" }}>BigBasket Snack Vending Machine</h3>
                                    <p className="text-black">Convenient vending machine stocked with premium snacks from BigBasket.</p>
                                    <p className="text-black">Advanced inventory tracking ensures fresh and readily available products.</p>
                                    <p className="text-black">Ideal for offices, malls, and high-footfall areas, offering quick and easy snack access.</p>
                                    <p className="text-black">Eco-friendly design with energy-efficient operations for sustainable usage.</p>
                                </Col>

                                <Col lg={6} md={12}>
                                    <div className='text-center'>
                                        <img src={wevend} alt="We Vend Logo" className="mb-3" style={{ width: "200px", height: 'auto' }} />
                                    </div>
                                    <h3 className="fw-bold " style={{ color: "rgb(52, 81, 159)" }}>We-Vend Snack Vending Machine</h3>
                                    <p className="text-black">AI-powered vending machine with an interactive touchscreen for a seamless user experience.</p>
                                    <p className="text-black">Energy-efficient and eco-friendly design for sustainable operations.</p>
                                    <p className="text-black">Supports digital wallets and contactless payment methods.</p>
                                </Col>
                                <Col lg={6} md={12} className="text-center">
                                    <img src={wevendSnack} alt="We-Vend Snack Vending Machine" className="img-fluid rounded" />
                                </Col>
                                
                            </Row>
                        </Col>
                    </Row>
                </Container>
                <EnquiryModal isOpen={modal} toggle={toggleModal} />
            </section>
            <section className="section  py-5" style={{ backgroundColor: " rgb(52, 81, 159)" }} id="features">
                <Container>
                    <Row className="justify-content-center">
                        <div className='text-center '>
                            <Button className='px-4 py-2 fw-bold' onClick={toggleModal}
                                style={{ background: "rgb(238, 99, 82)", borderRadius: "20px", color: "white", fontSize: "20px" }}
                            >
                                Enquiry Now
                            </Button>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default SnacksMachine;